import { SortingState, Updater } from '@tanstack/react-table';

import { Query } from '../../../shared/types/query.types';
import create from 'zustand';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { useCallback } from 'react';
import { useTableDataState } from './table-data.state';

export enum StatusSort {
   none,
   locked,
   active,
}

type ExpandedSortState = {
   sorting: SortingState;
   setSorting: (updaterOrState: Updater<any> | SortingState) => void;
   statusSort: StatusSort;
   setStatusSort: (type: StatusSort) => void;
};

export const useExpandedSortState = create<ExpandedSortState>((set, get) => ({
   sorting: [],
   setSorting: (updaterOrState) =>
      set(() => ({ sorting: typeof updaterOrState === 'function' ? updaterOrState(get().sorting) : updaterOrState })),
   statusSort: StatusSort.none,
   setStatusSort: (type: StatusSort) => set(() => ({ statusSort: type })),
}));

export const useSorting = () => {
   const [query, setQuery] = useTableDataState((state) => [state.query, state.setQuery]);

   const toggleSort = useCallback(
      (columnId: string) => {
         if (!query.orderBy || query.orderBy !== columnId) setQuery(merge({}, query, { orderBy: columnId, desc: false }));
         else {
            if (query.desc) setQuery(omit(query, ['orderBy', 'desc']) as Query);
            else setQuery(merge({}, query, { desc: true }));
         }
      },
      [query, setQuery]
   );

   const isColumnSortedDesc = (columId: string) => (columId === query.orderBy ? query.desc : undefined);

   return { toggleSort, isColumnSortedDesc };
};
